module.exports = __webpack_public_path__ + "static/media/logo-klaviyo.4ac5904c.png";